import React from 'react'
import * as moment from 'moment'
import { Formik } from 'formik'
import * as yup from 'yup'
import { Button, Select, Form, Drawer, DatePicker } from 'antd'

import LangContext, { i18n } from 'modules/shared/context/langContext'
const { RangePicker } = DatePicker
const { Option } = Select

const IndexIsDirtyFilterDrawer = (props) => (
  <Drawer
    title={
      <LangContext.Consumer>{(i18n) => i18n.f.filter}</LangContext.Consumer>
    }
    width={520}
    placement='right'
    onClose={props.onClose}
    maskClosable={true}
    visible={props.visible}
    style={{
      height: 'calc(100%)',
      overflow: 'auto',
      paddingBottom: 53,
    }}
  >
    <Formik
      enableReinitialize={true}
      initialValues={{
        stock_date: [
          moment(props.default_value.stock_date_start, 'YYYY-MM-DD'),
          moment(props.default_value.stock_date_end, 'YYYY-MM-DD'),
        ],
        plant_id: props.default_value.plant_id,
        material_id: props.default_value.material_id,
      }}
      validationSchema={yup.object().shape({
        stock_date: yup
          .array()
          .required('Required')
          // check end date - start date must be less than 31 days
          .test(
            'check-date-range',
            <LangContext.Consumer>
              {(i18n) => i18n.d.dateRangeNotBeMoreThan31Days}
            </LangContext.Consumer>,
            function(value) {
              let stock_date_start = moment(value[0]).format('YYYY-MM-DD')
              let stock_date_end = moment(value[1]).format('YYYY-MM-DD')

              const diff = moment(stock_date_end).diff(
                moment(stock_date_start),
                'days'
              )
              return diff <= 31
            }
          ),
      })}
      onSubmit={(values) => {
        props.onFilterButtonClick(values)
      }}
      render={({
        isValid,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        handleFocus,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Item
            label={
              <LangContext.Consumer>
                {(i18n) => i18n.s.stockDate}
              </LangContext.Consumer>
            }
            validateStatus={
              touched.stock_date && errors.stock_date && 'error'
            }
            help={touched.stock_date && errors.stock_date}
          >
            <RangePicker
              allowClear={false}
              style={{ width: '100%' }}
              value={values.stock_date}
              format={'DD/MM/YYYY'}
              onChange={(value) => {
                setFieldValue('stock_date', value)
                props.handleFilterObjStockDate(value)
              }}
            />
          </Form.Item>

          <Form.Item
            label={
              <LangContext.Consumer>
                {(i18n) => i18n.i.isupplyPlant}
              </LangContext.Consumer>
            }
          >
            <Select
              name='plant_id'
              style={{ width: '100%' }}
              value={values.plant_id}
              showSearch
              onChange={(value) => {
                setFieldValue('plant_id', value)
                props.handleFilterObjPlant(value)
              }}
              optionFilterProp='children'
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {props.plant_list &&
                props.plant_list.map((data, i) => (
                  <Option key={data.key} value={data.key}>
                    {data.title}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <LangContext.Consumer>
                {(i18n) => i18n.p.productType}
              </LangContext.Consumer>
            }
          >
            <Select
              name='material_id'
              style={{ width: '100%' }}
              value={values.material_id}
              showSearch
              onChange={(value) => {
                setFieldValue('material_id', value)
                props.handleFilterObjMaterial(value)
              }}
              optionFilterProp='children'
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {props.material_list &&
                props.material_list.map((data, i) => (
                  <Option key={data.key} value={data.key}>
                    {data.title}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button
              style={{
                marginRight: 8,
              }}
              onClick={props.onClose}
            >
              <LangContext.Consumer>
                {(i18n) => i18n.c.cancel}
              </LangContext.Consumer>
            </Button>

            <Button type='submit' htmlType='submit'>
              <LangContext.Consumer>
                {(i18n) => i18n.a.apply}
              </LangContext.Consumer>
            </Button>
          </Form.Item>
        </Form>
      )}
    />
  </Drawer>
)
export default IndexIsDirtyFilterDrawer
